import { normalizePrefillEmail, PREFILL_EMAIL_PARAM } from "../../shared/leadgen/prefill-email";

// index.html moves ?email= out of the URL before GTM loads, so the address
// never sits in the page URL that tags record. It lands in sessionStorage,
// or in this in-memory global when storage is blocked.
const STORAGE_KEY = "ts.prefill_email";

declare global {
  interface Window {
    __tsPrefillEmail?: string;
  }
}

export function readPrefillEmail(): string | null {
  if (typeof window === "undefined") return null;
  let stored: string | null = null;
  try {
    stored = window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    // Blocked storage: index.html kept the email in memory instead.
  }
  return normalizePrefillEmail(stored ?? window.__tsPrefillEmail);
}

/** Called once the OAuth start has the email, so a later connect in the
 *  same tab cannot reuse it. */
export function consumePrefillEmail(): void {
  if (typeof window === "undefined") return;
  delete window.__tsPrefillEmail;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage was never usable in this tab; the in-memory copy is gone.
  }
}

/** The current URL with the prefill email put back, for handing the page to
 *  another browser that has none of this tab's storage. */
export function urlWithPrefillEmail(href: string, email: string | null): string {
  if (!email) return href;
  const url = new URL(href);
  url.searchParams.set(PREFILL_EMAIL_PARAM, email);
  return url.href;
}
